// ExportUtils.js
// Utilitaires d’export (CSV / HTML / JSON) + téléchargement

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const exportCollectionToCSV = (files, language = 'fr') => {
  const headers = [
    language === 'fr' ? 'Fichier' : 'File',
    language === 'fr' ? 'Titre' : 'Title',
    language === 'fr' ? 'Artiste' : 'Artist',
    'Album',
    language === 'fr' ? 'Année' : 'Year',
    language === 'fr' ? 'Piste' : 'Track',
    'Genre'
  ].join(',');

  const rows = files.map(file => [
    `"${file.name}"`,
    `"${file?.tags?.title ?? ''}"`,
    `"${file?.tags?.artist ?? ''}"`,
    `"${file?.tags?.album ?? ''}"`,
    `"${file?.tags?.year ?? ''}"`,
    `"${file?.tags?.track ?? ''}"`,
    `"${file?.tags?.genre ?? ''}"`
  ].join(','));

  const csv = [headers, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv; charset=utf-8' });
  downloadBlob(blob, 'collection-tags.csv');
};

export const exportCollectionToHTML = (files, language = 'fr') => {
  const html = `<!DOCTYPE html>
<html lang="${language}">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${language === 'fr' ? 'Ma Collection Musicale' : 'My Music Collection'}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 20px; }
    table { border-collapse: collapse; width: 100%; }
    th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
    th { background-color: #f2f2f2; }
    tr:nth-child(even) { background-color: #f9f9f9; }
    .header { color: #333; margin-bottom: 20px; }
  </style>
</head>
<body>
  <div class="header">
    <h1>${language === 'fr' ? 'Ma Collection Musicale' : 'My Music Collection'}</h1>
    <p>${language === 'fr' ? 'Générée par MP3 Tag Editor Pro le' : 'Generated by MP3 Tag Editor Pro on'} ${new Date().toLocaleString(language === 'fr' ? 'fr-FR' : 'en-US')}</p>
  </div>
  <table>
    <tr>
      <th>${language === 'fr' ? 'Fichier' : 'File'}</th>
      <th>${language === 'fr' ? 'Titre' : 'Title'}</th>
      <th>${language === 'fr' ? 'Artiste' : 'Artist'}</th>
      <th>Album</th>
      <th>${language === 'fr' ? 'Année' : 'Year'}</th>
      <th>${language === 'fr' ? 'Piste' : 'Track'}</th>
      <th>Genre</th>
      <th>${language === 'fr' ? 'Commentaire' : 'Comment'}</th>
    </tr>
    ${files.map(file => `
    <tr>
      <td>${file.name}</td>
      <td>${file?.tags?.title ?? ''}</td>
      <td>${file?.tags?.artist ?? ''}</td>
      <td>${file?.tags?.album ?? ''}</td>
      <td>${file?.tags?.year ?? ''}</td>
      <td>${file?.tags?.track ?? ''}</td>
      <td>${file?.tags?.genre ?? ''}</td>
      <td>${file?.tags?.comment ?? ''}</td>
    </tr>`).join('')}
  </table>
</body>
</html>`;

  const blob = new Blob([html], { type: 'text/html; charset=utf-8' });
  downloadBlob(blob, 'collection.html');
};

export const exportCollectionToJSON = (files) => {
  const content = JSON.stringify(
    files.map(file => ({
      filename: file.name,
      tags: file.tags,
      metadata: {
        size: file.size,
        type: file.type,
        lastModified: file.lastModified
      }
    })),
    null,
    2
  );
  const blob = new Blob([content], { type: 'application/json' });
  downloadBlob(blob, 'collection-metadata.json');
};
